import { useState } from 'react';
import { Collapse } from '@mui/material';
import { TaskHeader } from 'app/agriculture/routes/Tasks/components/TaskHeader/TaskHeader';
import { TaskStats } from 'app/agriculture/routes/Tasks/components/TaskStats/TaskStats';
import './TaskRow.scss';
import { AgExpandIconButton } from 'app/agriculture/infobox/common/AgExpandIcon/AgExpandIcon';
import { ExpandableTypography } from 'app/agriculture/infobox/components/ExpandableTypography/ExpandableTypography';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

interface Props {
    task: Task;
}

export function TaskRow({ task }: Props) {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="TaskRow" data-testid="TaskRow">
            <div className="TaskRow__header" data-testid="task-row-header">
                <div className="TaskRow__title">
                    <TaskHeader taskId={task.id} enableTitleLink />
                </div>
                <AgExpandIconButton
                    expanded={expanded}
                    onClick={() => {
                        setExpanded((expanded) => !expanded);
                    }}
                />
            </div>
            <Collapse in={expanded}>
                <div className="TaskRow__content">
                    {task.description == null ? null : (
                        <div className="TaskRow__description">
                            <ExpandableTypography
                                id="task-row-description"
                                text={task.description}
                                maxLines={2}
                            />
                        </div>
                    )}
                    <div className="TaskRow__stats">
                        <TaskStats taskId={task.id} showEditAction />
                    </div>
                </div>
            </Collapse>
        </div>
    );
}
